import React from 'react';
import { combineClassNames } from '../../../core/css';

const OptionsGrid = ({ role, className, children, analyticsKey }) => {
  const selectedChild = children.filter(
    (child) => child?.props?.option?.selected
  );

  const sanitizeAnaltyicsKey = (analyticsKey) => {
    return analyticsKey?.replace('<sup>&reg;</sup>', '')?.replace('&', 'and');
  };

  return (
    <div
      className={combineClassNames('option-grid', 'stat-wrapper')}
      role={role}
      data-dtm={sanitizeAnaltyicsKey(analyticsKey)}
      data-dtm2={sanitizeAnaltyicsKey(selectedChild[0]?.props?.analyticsKey2)}>
      {children}
    </div>
  );
};

export default OptionsGrid;
